import { CARGOS, useEscala } from '@/lib/escala';

/**
 * Mostra o cargo e a escala do mandato na barra superior.
 *
 * ERA UM SELETOR, E ISSO ERA UM DEFEITO. O `<select>` chamava `useSalvarCargo`
 * a cada troca, gravando `mandato.cargo` no servidor: qualquer pessoa
 * autenticada transformava uma vereadora em senadora por um menu da barra de
 * ferramentas, sem confirmação e sem saber o que estava fazendo.
 *
 * E o estrago não parava no rótulo. O cargo define a ESCALA de todo o sistema
 * -- bairro para vereador, município para deputado, estado para presidente --
 * e com ela o recorte do território, das metas, da matriz de performance e da
 * comparação com a apuração do TSE. Trocar o cargo por engano não deixava a
 * tela errada: deixava a análise inteira medindo outra coisa.
 *
 * Cargo é fato do mandato, estabelecido no cadastro. Corrigi-lo continua
 * possível em Configurações, que é uma tela de administração onde a mudança é
 * deliberada -- não um menu que se abre por acidente ao lado do relógio.
 */
export function SeletorEscala() {
  const { cargo } = useEscala();

  return (
    <span className="chip" id="escala" aria-label="Escala do mandato">
      {CARGOS[cargo]?.rotulo ?? cargo}
    </span>
  );
}
